import React from 'react';

import Typography from '~/components/core/Atomic/Typography';

interface ImportConfirmationStepProps {
  totalClaims: number;
}

const ImportConfirmationStep: React.FC<ImportConfirmationStepProps> = ({ totalClaims }) => {
  return (
    <div className="flex flex-col items-center justify-center gap-16 p-24">
      <Typography variant="h6">Import Started</Typography>
      <Typography>
        {totalClaims} claims queued for processing. Track progress in the Run History section below.
      </Typography>
    </div>
  );
};

export default ImportConfirmationStep;
